import BaseComparison from './baseComparison';

class GreaterThan extends BaseComparison {
    constructor(registry) {
        super("greaterThan", registry);
    }

    compareValues(value1, value2) {
        return value1 > value2;
    }
}

export default GreaterThan;
